module.exports = __webpack_public_path__ + "media/images/group_insurances/banner-md-3689d2f4343472e36db938f1970aa06e.jpg";